import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputPhoneNumberUI from '../../widgets/form/InputPhoneNumberUI'

const PhoneUpdateStep1UI = ({ context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
  // old phone number
  oldPhoneNumber, onOldPhoneNumberChange, oldPhoneNumberError, setOldPhoneNumberError,
  // new phone number
  newPhoneNumber, onNewPhoneNumberChange, newPhoneNumberError, setNewPhoneNumberError
}) =>
  <CardUI context={context}>
    <FormSF context={context} className='pg_upd_phone' messageList={messageList} buttonMessageKey='c_continue'
      onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      busy={submitted}>
      <InputPhoneNumberUI name='oldPhoneNumber' required={true} disabled={true}
        messageList={messageList} labelKey='c_phone_number_existing'
        value={oldPhoneNumber} onChange={onOldPhoneNumberChange}
        error={oldPhoneNumberError} setError={setOldPhoneNumberError}
      />
      <InputPhoneNumberUI name='newPhoneNumber' required={true} autoFocus={true}
        messageList={messageList} labelKey='c_phone_number_new' helpKey='c_tip_verify_phone'
        value={newPhoneNumber} onChange={onNewPhoneNumberChange}
        error={newPhoneNumberError} setError={setNewPhoneNumberError}
      />
    </FormSF>
  </CardUI>

export default PhoneUpdateStep1UI
